import React from 'react';
import Table from '../../../components/Table/Table/Table';
import { FaWarehouse, FaIndustry } from 'react-icons/fa';
import { processTableColumns, productBOMTableColumns } from '../context';
import '../ProductManagement.css';

const ProductDetailTables = ({
  clickedRow,
  processesData,
  processPage,
  processesPaging,
  productBOMData,
  productBOMPage,
  productBOMPaging,
  crud,
  promptDelete
}) => {
  return (
    <div className="bottom-table-container">
      <div className="left-table">
        <Table
          showSearchBar={false}
          columns={processTableColumns(crud, promptDelete)}
          title={<><FaWarehouse style={{ marginRight: '8px' }} /> 공정</>}
          data={processesData}
          page={processPage}
          paging={processesPaging}
          onAddClick={() => crud(1, 2)}
        />
      </div>
      <div className="right-table">
        <Table
          showSearchBar={false}
          title={<><FaIndustry style={{ marginRight: '8px' }} /> 자재</>}
          columns={productBOMTableColumns(crud, promptDelete)}
          data={productBOMData}
          page={productBOMPage}
          paging={productBOMPaging}
          onAddClick={() => crud(1, 3)}
        />
      </div>
    </div>
  );
};

export default ProductDetailTables;
